import React from 'react';
export const PageLoader = ({ text }) => {
    return (React.createElement("div", { className: "flex flex-col w-full min-h-screen" },
        React.createElement("div", { className: "flex-1 flex items-center justify-center bg-gray-50" },
            React.createElement("div", { className: "text-center" },
                React.createElement("div", { className: "inline-block animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900" }),
                React.createElement("p", { className: "mt-4 text-gray-600" }, text)))));
};
